<tt-page>
    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0 height-full">
    <tt-grid ng-if="vm.model.gridReady" class="col-xs-12 sp-0 flex-1" tt-options="vm.grid"></tt-grid>
</tt-page>-->
